import { render, staticRenderFns } from "./crudPriceListSuppliers.vue?vue&type=template&id=ce410746&scoped=true&"
import script from "./crudPriceListSuppliers.vue?vue&type=script&lang=js&"
export * from "./crudPriceListSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./crudPriceListSuppliers.vue?vue&type=style&index=0&id=ce410746&prod&lang=css&"
import style1 from "./crudPriceListSuppliers.vue?vue&type=style&index=1&id=ce410746&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce410746",
  null
  
)

export default component.exports